import { DEBOUNCE_DELAY } from '~/vue_shared/components/filtered_search_bar/constants';
import currentUserFrecentProjectsQueryWithDashboards from './graphql/current_user_frecent_projects_with_dashboards.query.graphql';
import DashboardItemsList from './dashboard_items_list.vue?vue3';
import { hasDashboard } from './utils';
export default {
    name: 'DashboardFrequentProjects',
    components: {
        DashboardItemsList
    },
    props: {
        dashboardName: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            frecentProjects: undefined
        };
    },
    apollo: {
        frecentProjects: {
            query: currentUserFrecentProjectsQueryWithDashboards,
            debounce: DEBOUNCE_DELAY
        }
    },
    computed: {
        items () {
            return this.frecentProjects?.filter((project)=>hasDashboard(project, this.dashboardName)) || [];
        }
    }
};
